import React, { useContext, useState } from "react";
import MyModal from "./MyModal";
import OtherContext from "../Context/Notes/OthersContext";
import nodeContext from "../Context/Notes/NotesContext";

function About() {
  return (
    <div className="about_page container">
      <h2>About iNotebook</h2>
      <p>
        Welcome to our iNotebook Application, your digital companion for all
        your note-taking needs! We're here to make your life easier, more
        organized, and more efficient. Whether you're a student, professional,
        or just someone who loves jotting down ideas, our Notes Application has
        you covered.
      </p>
      <h3>Our Mission</h3>
      <p>
        At our core, we believe in the power of information and the importance
        of capturing thoughts, ideas, and insights. Our mission is to provide
        you with a seamless and user-friendly platform to do just that. We aim
        to simplify the process of note-taking while ensuring that your notes
        are always accessible and well-organized.
      </p>
      <h3>Key Features</h3>
      <div>
        <h6>1. Easy to Use</h6>

        <h6>2. Seamless Synchronization</h6>

        <h6>3. Organization</h6>

        <h6>4. Security</h6>

        <h6>5. Collaboration</h6>

        <h6>6. Cross-Platform Compatibility</h6>
      </div>
      <h3> Our Vision</h3>
      <p>
        As we continue to evolve and improve our iNotebook Application, we have
        a vision of becoming the go-to platform for all your note-taking needs.
        We aim to expand our features, integrate with other productivity tools,
        and listen to your feedback to provide you with the best note-taking
        experience possible.
      </p>
      <h3>Contact Us</h3>
      <p>
        We value your input and are always here to assist you. If you have any
        questions, feedback, or suggestions, please don't hesitate to contact
        our support team. You can reach us via email, chat, or through our
        social media channels. Your insights help us make our iNotebook
        Application even better. Thank you for choosing our iNotebook
        Application to accompany you on your note-taking journey. We look
        forward to helping you capture and organize your ideas, thoughts, and
        inspiration, making your life more productive and organized.
      </p>
    </div>
  );
}

export default About;
